import { render } from "./Remarks.vue?vue&type=template&id=1eb44f29&scoped=true&ts=true"
import script from "./Remarks.vue?vue&type=script&lang=ts"
export * from "./Remarks.vue?vue&type=script&lang=ts"

import "./Remarks.vue?vue&type=style&index=0&id=1eb44f29&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb44f29"]])

export default __exports__